import * as React from 'react';
import { useParams } from 'react-router-dom';
import { logWarn } from 'logging';

import { useGoToPath } from 'catering/hooks/navigation';
import {
  selectAreAllLocationsClosed,
  selectCateringLocationBySlug,
  useCateringLocations
} from 'catering/hooks/query';
import { useAccount } from 'catering/context/providers/AccountProvider';
import {
  LOCATION_OFFLINE_PATH,
  LOCATIONS_PATH
} from 'catering/constants/paths';

export function useRedirectToLocationOffline(redirectConditions = []) {
  const { locationSlug } = useParams();
  const { go } = useGoToPath();
  const { storeTemporarilyDisabled } = useAccount();
  const {
    isLoading: isLoadingLocationsData,
    data: cateringLocationsData
  } = useCateringLocations({
    select: locations => {
      let shouldRedirectToOffline = selectAreAllLocationsClosed(locations);
      const selectedLocation =
        selectCateringLocationBySlug(locations, locationSlug) || null;
      if (selectedLocation) {
        shouldRedirectToOffline = selectedLocation.is_closed;
      }
      return { selectedLocation, shouldRedirectToOffline };
    }
  });

  for (const condition of redirectConditions) {
    if (condition.shouldRedirect) {
      if (condition.logMessage) {
        logWarn(condition.logMessage(locationSlug));
      }
      go({ path: LOCATION_OFFLINE_PATH, isRedirect: true });
      break;
    }
  }

  React.useEffect(() => {
    if (
      (cateringLocationsData &&
        cateringLocationsData.shouldRedirectToOffline) ||
      storeTemporarilyDisabled
    ) {
      go({ path: LOCATION_OFFLINE_PATH, isRedirect: true });
    } else if (
      cateringLocationsData &&
      cateringLocationsData.selectedLocation === null
    ) {
      go({ path: LOCATIONS_PATH, isRedirect: true });
    }
  }, [isLoadingLocationsData, cateringLocationsData]);
}
